import { gql } from '@apollo/client';

export const UPDATE_USER_SESSION = gql`
  mutation updateUserSession($input: UserSessionUpdateInput!) {
    updateUserSession(input: $input) {
      _id
    }
  }
`;